import {
  Box,
  Checkbox,
} from "@chakra-ui/react";
import { useUserInterfaceStore } from "../../store";

const ToolbarPanel = () => {
  const snappingForEditor = useUserInterfaceStore((s) => s.snappingForEditor);
  const setSnappingForEditor = useUserInterfaceStore(
    (s) => s.setSnappingForEditor
  );

  return (
    <Box
      bg="white"
      border="2px solid #000"
      borderRadius="0"
      overflow="visible"
      color="black"
      position="relative"
      h="40px"
      px={6}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Checkbox.Root
        defaultChecked
        variant={"solid"}
        checked={snappingForEditor}
        onCheckedChange={(e) => setSnappingForEditor(!!e.checked)}
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control
          borderColor="black"
          color="white"
          _checked={{ bg: "black", borderColor: "black", color: "white" }}
        />
        <Checkbox.Label color="black">Snapping</Checkbox.Label>
      </Checkbox.Root>
    </Box>
  );
};

export default ToolbarPanel;
